import { useActiveUserContext, useAssignedAppTypeContext, useDataRequestPermissionsContext } from '@vivli/core/infrastructure/context';
import { PermissionsEnum } from '@vivli/shared/infrastructure/enum';
import { DataRequestStatusEnum } from '@vivli/features/data-requests/infrastructure/enum';
import { IDataRequest } from '@vivli/features/data-requests/infrastructure/interface';
import { IOrganization } from '@vivli/features/organizations/infrastructure/interface';

export function useDataRequestDefaultTabHook() {
    const { userIsContributorOrIRPApprover, shouldHideReviewers } = useDataRequestPermissionsContext();
    const { user: activeUser, hasPermission, orgHasPermission } = useActiveUserContext();
    const { isAmr } = useAssignedAppTypeContext();
    const isVivliAdmin = hasPermission(PermissionsEnum.DrActAdv);

    const getAmrRowClick = (isDraft: boolean, isContributorOrIRPApprover: boolean, isOwner: boolean) => {
        const isContributorIrpOrNotDraft = isContributorOrIRPApprover || !isDraft;
        const secondaryAmrPath = isContributorIrpOrNotDraft ? 'printview' : 'request';
        //TODO PERMFE - redo with permissions+
        const amrTabPath = isVivliAdmin && !isOwner ? 'requestprintview' : secondaryAmrPath;
        return amrTabPath;
    };

    const getDefaultTabRoute = (dataRequest: IDataRequest, organizations: IOrganization[], requestStatus: string) => {
        const teamMember = dataRequest.researchTeam.researchTeamDetails.find((x) => x.userId === activeUser.userId);
        const shouldHideReviews = shouldHideReviewers(dataRequest, organizations);
        const isContributorOrIRPApprover = userIsContributorOrIRPApprover(dataRequest, organizations);
        const isDraft = dataRequest.status === DataRequestStatusEnum.Draft;
        const isOwner = dataRequest.userId === activeUser.userId;
        //TODO PERMFE - redo with permissions+
        const navTabPath = isDraft && (teamMember || isVivliAdmin || isOwner) && !shouldHideReviews ? 'researchTeam' : 'chat';
        const amrTabPath = getAmrRowClick(isDraft, isContributorOrIRPApprover, isOwner);
        const chosenTab = isAmr ? amrTabPath : navTabPath;
        const orgAdmin = activeUser.orgMemberships?.some((om) =>
            organizations.some((o) => orgHasPermission(o.id, PermissionsEnum.ProviderActAdv))
        );
        //TODO PERMFE - redo with permissions+
        const chosenRoute = isDraft && ((!isVivliAdmin && !orgAdmin) || isOwner) ? 'myDataRequestDetails' : 'admindatarequests';

        return `/${chosenRoute}/${requestStatus}/${dataRequest.id}/${chosenTab}`;
    };

    return {
        getDefaultTabRoute,
    };
}
